var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4187 13.5931L9.75948 22.3157L7.51952 22.3017L10.3486 13.5615L4.34551 13.524L2.47962 16.7966L0.799655 16.7861L1.91963 11.8667L0.799655 6.93343L2.47962 6.94392L4.34663 10.2398L10.3497 10.2773L7.51952 1.50171L9.75948 1.51569L15.4187 10.3089L21.5193 10.347C21.9648 10.3498 22.3921 10.5255 22.7072 10.8354C23.0222 11.1453 23.1992 11.5641 23.1992 11.9996C23.1992 12.4351 23.0222 12.8517 22.7072 13.1577C22.3921 13.4637 21.9648 13.634 21.5193 13.6312L15.4187 13.5931Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneGrey);
export default __webpack_public_path__ + "static/media/plane_grey.bdba5c653fd7e46cc6f729386fa241e8.svg";
export { ForwardRef as ReactComponent };